<script lang="ts">
  import type { IconsBaseProps } from './icons.types.ts';

  let { class: className, size = 6, title, ...rest }: IconsBaseProps = $props();
</script>

<svg viewBox="0 0 24 24" {...rest} width={size * 4} height={size * 4} class={className}>
  {#if title}<title>{title}</title>{/if}
  <path
    d="M5.69997 6.71047C5.30997 7.10047 5.30997 7.73047 5.69997 8.12047L9.57997 12.0005L5.69997 15.8805C5.30997 16.2705 5.30997 16.9005 5.69997 17.2905C6.08997 17.6805 6.71997 17.6805 7.10997 17.2905L11.7 12.7005C12.09 12.3105 12.09 11.6805 11.7 11.2905L7.11997 6.71047C6.72997 6.32047 6.08997 6.32047 5.69997 6.71047Z"
    fill="currentColor"
  /><path
    d="M12.2901 6.70978C11.9001 7.09978 11.9001 7.72978 12.2901 8.11978L16.1701 11.9998L12.2901 15.8798C11.9001 16.2698 11.9001 16.8998 12.2901 17.2898C12.6801 17.6798 13.3101 17.6798 13.7001 17.2898L18.2901 12.6998C18.6801 12.3098 18.6801 11.6798 18.2901 11.2898L13.7001 6.69978C13.3201 6.31978 12.6801 6.31978 12.2901 6.70978Z"
    fill="currentColor"
  />
</svg>
